import styled from 'styled-components';
import { Color } from '../../../../common/view/color/color';

const Container = styled.div.withConfig({
  componentId: 'mega-board_container',
  displayName: 'MegaBoard.Container',
})`
  padding: 40px;

  width: max-content;
  height: max-content;
`;

const Title = styled.div.withConfig({
  componentId: 'mega-board_title',
  displayName: 'MegaBoard.Title',
})`
  font-size: 36px;
  font-weight: bold;
  color: ${Color.white2};

  &:focus-visible {
    outline: none;
  }
`;

export const MegaBoardStyle = {
  Container,
  Title,
};
